import * as React from 'react'
import { Switch as SwitchPrimitive } from 'radix-ui'

import { cn } from '@/lib/utils'

function Switch({
  className,
  size = 'default',
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root> & {
  size?: 'sm' | 'default'
}) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      data-size={size}
      className={cn(
        'peer group/switch inline-flex shrink-0 items-center rounded-full transition-[color,background-color,border-color,box-shadow,opacity] outline-none',
        'focus-visible:ring-2 focus-visible:ring-primary-solid focus-visible:ring-offset-2',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'data-[state=checked]:bg-primary-solid data-[state=unchecked]:bg-neutral-solid',
        'data-[size=default]:w-[42px] data-[size=default]:h-[25px]',
        'data-[size=sm]:w-[28px] data-[size=sm]:h-[16px]',
        className
      )}
      {...props}>
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          'pointer-events-none block rounded-full bg-primary-app-bg transition-transform',
          'group-data-[size=default]/switch:size-[21px]',
          'group-data-[size=sm]/switch:size-[12px]',
          'group-data-[size=default]/switch:data-[state=unchecked]:translate-x-[2px]',
          'group-data-[size=default]/switch:data-[state=checked]:translate-x-[19px]',
          'group-data-[size=sm]/switch:data-[state=unchecked]:translate-x-[2px]',
          'group-data-[size=sm]/switch:data-[state=checked]:translate-x-[14px]'
        )}
      />
    </SwitchPrimitive.Root>
  )
}

export { Switch }
